export interface Emoji {
  emoji: string;
  name: string;
  keywords: string[];
}

export interface EmojiGroup {
  name: string;
  emojis: Emoji[];
}

export const emojiData: EmojiGroup[] = [
  {
    name: 'Smileys & Emotion',
    emojis: [
      {emoji: '😀', name: 'grinning face', keywords: ['smile', 'happy']},
      {emoji: '😃', name: 'grinning face with big eyes', keywords: ['happy', 'joy', 'smile']},
      {emoji: '😄', name: 'grinning face with smiling eyes', keywords: ['happy', 'joy']},
      {emoji: '😁', name: 'beaming face with smiling eyes', keywords: ['teeth']},
      {emoji: '😆', name: 'grinning squinting face', keywords: ['happy', 'laugh']},
      {emoji: '😅', name: 'grinning face with sweat', keywords: ['hot', 'sweat']},
      {emoji: '🤣', name: 'rolling on the floor laughing', keywords: ['lol', 'laugh']},
      {emoji: '😂', name: 'face with tears of joy', keywords: ['tears', 'laugh']},
      {emoji: '🙂', name: 'slightly smiling face', keywords: ['smile']},
      {emoji: '😊', name: 'smiling face with smiling eyes', keywords: ['smile', 'blush']},
      {emoji: '😇', name: 'smiling face with halo', keywords: ['angel']},
      {emoji: '🥰', name: 'smiling face with hearts', keywords: ['love']},
      {emoji: '😍', name: 'smiling face with heart-eyes', keywords: ['love', 'heart']},
      {emoji: '😘', name: 'face blowing a kiss', keywords: ['kiss']},
      {emoji: '😗', name: 'kissing face', keywords: ['kiss']},
      {emoji: '😙', name: 'kissing face with smiling eyes', keywords: ['kiss']},
      {emoji: '😚', name: 'kissing face with closed eyes', keywords: ['kiss']},
      {emoji: '😋', name: 'face savoring food', keywords: ['tongue', 'yum']},
      {emoji: '😛', name: 'face with tongue', keywords: ['tongue']},
      {emoji: '😜', name: 'winking face with tongue', keywords: ['wink', 'tongue']},
      {emoji: '🤪', name: 'zany face', keywords: ['crazy']},
      {emoji: '😝', name: 'squinting face with tongue', keywords: ['tongue']},
      {emoji: '🤑', name: 'money-mouth face', keywords: ['money', 'dollar']},
      {emoji: '🤗', name: 'hugging face', keywords: ['hug']},
      {emoji: '🤭', name: 'face with hand over mouth', keywords: ['oops']},
      {emoji: '🤫', name: 'shushing face', keywords: ['quiet', 'shh']},
      {emoji: '🤔', name: 'thinking face', keywords: ['think']},
      {emoji: '😶', name: 'face without mouth', keywords: ['mute', 'silent']},
      {emoji: '😏', name: 'smirking face', keywords: ['smirk']},
      {emoji: '😒', name: 'unamused face', keywords: ['meh']},
      {emoji: '🙄', name: 'face with rolling eyes', keywords: ['eyeroll']},
      {emoji: '😬', name: 'grimacing face', keywords: ['grimace']},
      {emoji: '😮', name: 'face with open mouth', keywords: ['surprise']},
      {emoji: '😯', name: 'hushed face', keywords: ['surprise']},
      {emoji: '😲', name: 'astonished face', keywords: ['amazed']},
      {emoji: '😳', name: 'flushed face', keywords: ['blush']},
      {emoji: '🥺', name: 'pleading face', keywords: ['puppy', 'eyes']},
      {emoji: '😦', name: 'frowning face with open mouth', keywords: ['frown']},
      {emoji: '😧', name: 'anguished face', keywords: ['stunned']},
      {emoji: '😨', name: 'fearful face', keywords: ['scared']},
      {emoji: '😰', name: 'anxious face with sweat', keywords: ['nervous']},
      {emoji: '😥', name: 'sad but relieved face', keywords: ['phew']},
      {emoji: '😢', name: 'crying face', keywords: ['sad', 'tear']},
      {emoji: '😭', name: 'loudly crying face', keywords: ['sad', 'cry']},
      {emoji: '😱', name: 'face screaming in fear', keywords: ['scream', 'scared']},
      {emoji: '😖', name: 'confounded face', keywords: ['confused']},
      {emoji: '😣', name: 'persevering face', keywords: ['struggling']},
      {emoji: '😞', name: 'disappointed face', keywords: ['sad']},
      {emoji: '😓', name: 'downcast face with sweat', keywords: ['sweat']},
      {emoji: '😤', name: 'face with steam from nose', keywords: ['triumph']},
      {emoji: '😡', name: 'pouting face', keywords: ['angry', 'mad']},
      {emoji: '😠', name: 'angry face', keywords: ['mad']},
      {emoji: '🤬', name: 'face with symbols on mouth', keywords: ['swearing']},
      {emoji: '😈', name: 'smiling face with horns', keywords: ['devil']},
      {emoji: '👿', name: 'angry face with horns', keywords: ['devil', 'angry']},
      {emoji: '💀', name: 'skull', keywords: ['dead']},
      {emoji: '☠️', name: 'skull and crossbones', keywords: ['dead', 'danger']},
      {emoji: '💩', name: 'pile of poo', keywords: ['poop']},
      {emoji: '🤡', name: 'clown face', keywords: ['clown']},
      {emoji: '👻', name: 'ghost', keywords: ['spooky']},
      {emoji: '👽', name: 'alien', keywords: ['ufo']},
      {emoji: '🤖', name: 'robot', keywords: ['robot']},
      {emoji: '😺', name: 'grinning cat', keywords: ['cat']},
      {emoji: '😸', name: 'grinning cat with smiling eyes', keywords: ['cat']},
      {emoji: '😹', name: 'cat with tears of joy', keywords: ['cat']},
      {emoji: '😻', name: 'smiling cat with heart-eyes', keywords: ['cat', 'love']},
      {emoji: '😼', name: 'cat with wry smile', keywords: ['cat']},
      {emoji: '😽', name: 'kissing cat', keywords: ['cat']},
      {emoji: '🙀', name: 'weary cat', keywords: ['cat', 'surprised']},
      {emoji: '😿', name: 'crying cat', keywords: ['cat', 'sad']},
      {emoji: '😾', name: 'pouting cat', keywords: ['cat', 'angry']},
      {emoji: '❤️', name: 'red heart', keywords: ['love', 'heart']},
      {emoji: '🧡', name: 'orange heart', keywords: ['love', 'heart']},
      {emoji: '💛', name: 'yellow heart', keywords: ['love', 'heart']},
      {emoji: '💚', name: 'green heart', keywords: ['love', 'heart']},
      {emoji: '💙', name: 'blue heart', keywords: ['love', 'heart']},
      {emoji: '💜', name: 'purple heart', keywords: ['love', 'heart']},
      {emoji: '🖤', name: 'black heart', keywords: ['heart']},
      {emoji: '💔', name: 'broken heart', keywords: ['heartbreak']},
      {emoji: '❤️‍🔥', name: 'heart on fire', keywords: ['love', 'burn']},
      {emoji: '💕', name: 'two hearts', keywords: ['love']},
      {emoji: '💖', name: 'sparkling heart', keywords: ['love']},
      {emoji: '💗', name: 'growing heart', keywords: ['love']},
      {emoji: '💓', name: 'beating heart', keywords: ['love']},
      {emoji: '💘', name: 'heart with arrow', keywords: ['love', 'cupid']},
      {emoji: '💝', name: 'heart with ribbon', keywords: ['gift']},
      {emoji: '💟', name: 'heart decoration', keywords: ['love']},
      {emoji: '💌', name: 'love letter', keywords: ['email', 'love']},
      {emoji: '💋', name: 'kiss mark', keywords: ['lips']},
      {emoji: '💯', name: 'hundred points', keywords: ['100', 'perfect']},
      {emoji: '💢', name: 'anger symbol', keywords: ['angry']},
      {emoji: '💥', name: 'collision', keywords: ['boom']},
      {emoji: '💫', name: 'dizzy', keywords: ['star']},
      {emoji: '💦', name: 'sweat droplets', keywords: ['water']},
      {emoji: '💨', name: 'dashing away', keywords: ['wind', 'fast']},
      {emoji: '🕳️', name: 'hole', keywords: ['hole']},
      {emoji: '💤', name: 'zzz', keywords: ['sleep']},
    ],
  },
  {
    name: 'People & Body',
    emojis: [
      {emoji: '👋', name: 'waving hand', keywords: ['wave', 'hello', 'bye']},
      {emoji: '🤚', name: 'raised back of hand', keywords: ['stop']},
      {emoji: '🖐️', name: 'hand with fingers splayed', keywords: ['hand']},
      {emoji: '✋', name: 'raised hand', keywords: ['stop', 'high five']},
      {emoji: '🖖', name: 'vulcan salute', keywords: ['spock']},
      {emoji: '👌', name: 'ok hand', keywords: ['ok']},
      {emoji: '✌️', name: 'victory hand', keywords: ['peace']},
      {emoji: '🤞', name: 'crossed fingers', keywords: ['luck', 'hope']},
      {emoji: '🤟', name: 'love-you gesture', keywords: ['ily']},
      {emoji: '🤘', name: 'sign of the horns', keywords: ['rock']},
      {emoji: '🤙', name: 'call me hand', keywords: ['call']},
      {emoji: '👈', name: 'backhand index pointing left', keywords: ['left', 'point']},
      {emoji: '👉', name: 'backhand index pointing right', keywords: ['right', 'point']},
      {emoji: '👆', name: 'backhand index pointing up', keywords: ['up', 'point']},
      {emoji: '🖕', name: 'middle finger', keywords: ['fu']},
      {emoji: '👇', name: 'backhand index pointing down', keywords: ['down', 'point']},
      {emoji: '☝️', name: 'index pointing up', keywords: ['up', 'point']},
      {emoji: '👍', name: 'thumbs up', keywords: ['like', 'yes']},
      {emoji: '👎', name: 'thumbs down', keywords: ['dislike', 'no']},
      {emoji: '✊', name: 'raised fist', keywords: ['power']},
      {emoji: '👊', name: 'oncoming fist', keywords: ['punch']},
      {emoji: '🤛', name: 'left-facing fist', keywords: ['fist']},
      {emoji: '🤜', name: 'right-facing fist', keywords: ['fist']},
      {emoji: '👏', name: 'clapping hands', keywords: ['clap', 'applause']},
      {emoji: '🙌', name: 'raising hands', keywords: ['hooray']},
      {emoji: '👐', name: 'open hands', keywords: ['hug']},
      {emoji: '🤲', name: 'palms up together', keywords: ['pray']},
      {emoji: '🤝', name: 'handshake', keywords: ['deal']},
      {emoji: '🙏', name: 'folded hands', keywords: ['pray', 'thanks']},
      {emoji: '💪', name: 'flexed biceps', keywords: ['muscle', 'strong']},
      {emoji: '🦵', name: 'leg', keywords: ['kick']},
      {emoji: '🦶', name: 'foot', keywords: ['stomp']},
      {emoji: '👂', name: 'ear', keywords: ['hear', 'listen']},
      {emoji: '👃', name: 'nose', keywords: ['smell']},
      {emoji: '🧠', name: 'brain', keywords: ['smart']},
      {emoji: '🦷', name: 'tooth', keywords: ['dentist']},
      {emoji: '🦴', name: 'bone', keywords: ['skeleton']},
      {emoji: '👀', name: 'eyes', keywords: ['look', 'see']},
      {emoji: '👁️', name: 'eye', keywords: ['watch']},
      {emoji: '👅', name: 'tongue', keywords: ['taste']},
      {emoji: '👄', name: 'mouth', keywords: ['lips']},
      {emoji: '👶', name: 'baby', keywords: ['child']},
      {emoji: '🧒', name: 'child', keywords: ['kid']},
      {emoji: '👦', name: 'boy', keywords: ['male']},
      {emoji: '👧', name: 'girl', keywords: ['female']},
      {emoji: '🧑', name: 'person', keywords: ['adult']},
      {emoji: '👱', name: 'person blond hair', keywords: ['blonde']},
      {emoji: '👨', name: 'man', keywords: ['male']},
      {emoji: '🧔', name: 'person beard', keywords: ['bearded']},
      {emoji: '👩', name: 'woman', keywords: ['female']},
      {emoji: '🧓', name: 'older person', keywords: ['old']},
      {emoji: '👴', name: 'old man', keywords: ['grandpa']},
      {emoji: '👵', name: 'old woman', keywords: ['grandma']},
    ],
  },
  {
    name: 'Animals & Nature',
    emojis: [
      {emoji: '🐶', name: 'dog face', keywords: ['pet', 'dog']},
      {emoji: '🐱', name: 'cat face', keywords: ['pet', 'cat']},
      {emoji: '🐭', name: 'mouse face', keywords: ['mouse']},
      {emoji: '🐹', name: 'hamster', keywords: ['pet']},
      {emoji: '🐰', name: 'rabbit face', keywords: ['bunny']},
      {emoji: '🦊', name: 'fox', keywords: ['fox']},
      {emoji: '🐻', name: 'bear', keywords: ['teddy']},
      {emoji: '🐼', name: 'panda', keywords: ['panda']},
      {emoji: '🐨', name: 'koala', keywords: ['koala']},
      {emoji: '🐯', name: 'tiger face', keywords: ['tiger']},
      {emoji: '🦁', name: 'lion', keywords: ['lion']},
      {emoji: '🐮', name: 'cow face', keywords: ['moo']},
      {emoji: '🐷', name: 'pig face', keywords: ['pig']},
      {emoji: '🐸', name: 'frog', keywords: ['frog']},
      {emoji: '🐵', name: 'monkey face', keywords: ['monkey']},
      {emoji: '🙈', name: 'see-no-evil monkey', keywords: ['monkey']},
      {emoji: '🙉', name: 'hear-no-evil monkey', keywords: ['monkey']},
      {emoji: '🙊', name: 'speak-no-evil monkey', keywords: ['monkey']},
      {emoji: '🐒', name: 'monkey', keywords: ['monkey']},
      {emoji: '🐔', name: 'chicken', keywords: ['chicken']},
      {emoji: '🐧', name: 'penguin', keywords: ['penguin']},
      {emoji: '🐦', name: 'bird', keywords: ['bird']},
      {emoji: '🐤', name: 'baby chick', keywords: ['chick']},
      {emoji: '🦆', name: 'duck', keywords: ['duck']},
      {emoji: '🦅', name: 'eagle', keywords: ['eagle']},
      {emoji: '🦉', name: 'owl', keywords: ['owl']},
      {emoji: '🦇', name: 'bat', keywords: ['bat']},
      {emoji: '🐺', name: 'wolf', keywords: ['wolf']},
      {emoji: '🐗', name: 'boar', keywords: ['pig']},
      {emoji: '🐴', name: 'horse face', keywords: ['horse']},
      {emoji: '🦄', name: 'unicorn', keywords: ['unicorn']},
      {emoji: '🐝', name: 'honeybee', keywords: ['bee']},
      {emoji: '🐛', name: 'bug', keywords: ['bug']},
      {emoji: '🦋', name: 'butterfly', keywords: ['butterfly']},
      {emoji: '🐌', name: 'snail', keywords: ['slow']},
      {emoji: '🐞', name: 'lady beetle', keywords: ['ladybug']},
      {emoji: '🐜', name: 'ant', keywords: ['ant']},
      {emoji: '🦟', name: 'mosquito', keywords: ['mosquito']},
      {emoji: '🦗', name: 'cricket', keywords: ['cricket']},
      {emoji: '🕷️', name: 'spider', keywords: ['spider']},
      {emoji: '🦂', name: 'scorpion', keywords: ['scorpion']},
      {emoji: '🐢', name: 'turtle', keywords: ['turtle']},
      {emoji: '🐍', name: 'snake', keywords: ['snake']},
      {emoji: '🦎', name: 'lizard', keywords: ['lizard']},
      {emoji: '🐙', name: 'octopus', keywords: ['octopus']},
      {emoji: '🦑', name: 'squid', keywords: ['squid']},
      {emoji: '🦐', name: 'shrimp', keywords: ['shrimp']},
      {emoji: '🦞', name: 'lobster', keywords: ['lobster']},
      {emoji: '🦀', name: 'crab', keywords: ['crab']},
      {emoji: '🐡', name: 'blowfish', keywords: ['fish']},
      {emoji: '🐠', name: 'tropical fish', keywords: ['fish']},
      {emoji: '🐟', name: 'fish', keywords: ['fish']},
      {emoji: '🐬', name: 'dolphin', keywords: ['dolphin']},
      {emoji: '🐳', name: 'spouting whale', keywords: ['whale']},
      {emoji: '🐋', name: 'whale', keywords: ['whale']},
      {emoji: '🦈', name: 'shark', keywords: ['shark']},
      {emoji: '🐊', name: 'crocodile', keywords: ['crocodile']},
      {emoji: '🐅', name: 'tiger', keywords: ['tiger']},
      {emoji: '🐆', name: 'leopard', keywords: ['leopard']},
      {emoji: '🦓', name: 'zebra', keywords: ['zebra']},
      {emoji: '🦍', name: 'gorilla', keywords: ['gorilla']},
      {emoji: '🦧', name: 'orangutan', keywords: ['monkey']},
      {emoji: '🐘', name: 'elephant', keywords: ['elephant']},
      {emoji: '🦛', name: 'hippopotamus', keywords: ['hippo']},
      {emoji: '🦏', name: 'rhinoceros', keywords: ['rhino']},
      {emoji: '🐪', name: 'camel', keywords: ['camel']},
      {emoji: '🐫', name: 'two-hump camel', keywords: ['camel']},
      {emoji: '🦒', name: 'giraffe', keywords: ['giraffe']},
      {emoji: '🦘', name: 'kangaroo', keywords: ['kangaroo']},
      {emoji: '🐃', name: 'water buffalo', keywords: ['buffalo']},
      {emoji: '🐂', name: 'ox', keywords: ['ox']},
      {emoji: '🐄', name: 'cow', keywords: ['cow']},
      {emoji: '🐎', name: 'horse', keywords: ['horse']},
      {emoji: '🐖', name: 'pig', keywords: ['pig']},
      {emoji: '🐏', name: 'ram', keywords: ['sheep']},
      {emoji: '🐑', name: 'ewe', keywords: ['sheep']},
      {emoji: '🦙', name: 'llama', keywords: ['llama']},
      {emoji: '🐐', name: 'goat', keywords: ['goat']},
      {emoji: '🦌', name: 'deer', keywords: ['deer']},
      {emoji: '🐕', name: 'dog', keywords: ['dog']},
      {emoji: '🐩', name: 'poodle', keywords: ['dog']},
      {emoji: '🦮', name: 'guide dog', keywords: ['dog']},
      {emoji: '🐈', name: 'cat', keywords: ['cat']},
      {emoji: '🐓', name: 'rooster', keywords: ['rooster']},
      {emoji: '🦃', name: 'turkey', keywords: ['turkey']},
      {emoji: '🦚', name: 'peacock', keywords: ['peacock']},
      {emoji: '🦜', name: 'parrot', keywords: ['parrot']},
      {emoji: '🦢', name: 'swan', keywords: ['swan']},
      {emoji: '🦩', name: 'flamingo', keywords: ['flamingo']},
      {emoji: '🕊️', name: 'dove', keywords: ['peace']},
      {emoji: '🐇', name: 'rabbit', keywords: ['bunny']},
      {emoji: '🦝', name: 'raccoon', keywords: ['raccoon']},
      {emoji: '🦨', name: 'skunk', keywords: ['skunk']},
      {emoji: '🦡', name: 'badger', keywords: ['badger']},
      {emoji: '🦦', name: 'otter', keywords: ['otter']},
      {emoji: '🦥', name: 'sloth', keywords: ['sloth']},
      {emoji: '🐁', name: 'mouse', keywords: ['mouse']},
      {emoji: '🐀', name: 'rat', keywords: ['rat']},
      {emoji: '🐿️', name: 'chipmunk', keywords: ['chipmunk']},
      {emoji: '🦔', name: 'hedgehog', keywords: ['hedgehog']},
      {emoji: '🐾', name: 'paw prints', keywords: ['paw']},
      {emoji: '🐉', name: 'dragon', keywords: ['dragon']},
      {emoji: '🐲', name: 'dragon face', keywords: ['dragon']},
      {emoji: '🌵', name: 'cactus', keywords: ['desert']},
      {emoji: '🎄', name: 'christmas tree', keywords: ['christmas']},
      {emoji: '🌲', name: 'evergreen tree', keywords: ['tree']},
      {emoji: '🌳', name: 'deciduous tree', keywords: ['tree']},
      {emoji: '🌴', name: 'palm tree', keywords: ['tropical']},
      {emoji: '🌱', name: 'seedling', keywords: ['plant']},
      {emoji: '🌿', name: 'herb', keywords: ['plant']},
      {emoji: '☘️', name: 'shamrock', keywords: ['irish']},
      {emoji: '🍀', name: 'four leaf clover', keywords: ['luck']},
      {emoji: '🎍', name: 'pine decoration', keywords: ['bamboo']},
      {emoji: '🎋', name: 'tanabata tree', keywords: ['tree']},
      {emoji: '🍃', name: 'leaf fluttering in wind', keywords: ['leaf']},
      {emoji: '🍂', name: 'fallen leaf', keywords: ['autumn']},
      {emoji: '🍁', name: 'maple leaf', keywords: ['canada']},
      {emoji: '🌾', name: 'sheaf of rice', keywords: ['grain']},
      {emoji: '🌺', name: 'hibiscus', keywords: ['flower']},
      {emoji: '🌻', name: 'sunflower', keywords: ['flower']},
      {emoji: '🌹', name: 'rose', keywords: ['flower', 'love']},
      {emoji: '🥀', name: 'wilted flower', keywords: ['dead']},
      {emoji: '🌷', name: 'tulip', keywords: ['flower']},
      {emoji: '🌼', name: 'blossom', keywords: ['flower']},
      {emoji: '🌸', name: 'cherry blossom', keywords: ['flower', 'spring']},
      {emoji: '💐', name: 'bouquet', keywords: ['flowers']},
      {emoji: '🍄', name: 'mushroom', keywords: ['shroom']},
      {emoji: '🌰', name: 'chestnut', keywords: ['nut']},
      {emoji: '🌍', name: 'globe showing Europe-Africa', keywords: ['earth', 'world']},
      {emoji: '🌎', name: 'globe showing Americas', keywords: ['earth', 'world']},
      {emoji: '🌏', name: 'globe showing Asia-Australia', keywords: ['earth', 'world']},
      {emoji: '🌐', name: 'globe with meridians', keywords: ['world', 'web']},
      {emoji: '🪨', name: 'rock', keywords: ['stone']},
      {emoji: '🌑', name: 'new moon', keywords: ['moon']},
      {emoji: '🌒', name: 'waxing crescent moon', keywords: ['moon']},
      {emoji: '🌓', name: 'first quarter moon', keywords: ['moon']},
      {emoji: '🌔', name: 'waxing gibbous moon', keywords: ['moon']},
      {emoji: '🌕', name: 'full moon', keywords: ['moon']},
      {emoji: '🌖', name: 'waning gibbous moon', keywords: ['moon']},
      {emoji: '🌗', name: 'last quarter moon', keywords: ['moon']},
      {emoji: '🌘', name: 'waning crescent moon', keywords: ['moon']},
      {emoji: '🌙', name: 'crescent moon', keywords: ['night']},
      {emoji: '🌚', name: 'new moon face', keywords: ['moon']},
      {emoji: '🌛', name: 'first quarter moon face', keywords: ['moon']},
      {emoji: '🌜', name: 'last quarter moon face', keywords: ['moon']},
      {emoji: '☀️', name: 'sun', keywords: ['sunny', 'weather']},
      {emoji: '🌝', name: 'full moon face', keywords: ['moon']},
      {emoji: '🌞', name: 'sun with face', keywords: ['sun']},
      {emoji: '⭐', name: 'star', keywords: ['star']},
      {emoji: '🌟', name: 'glowing star', keywords: ['star']},
      {emoji: '🌠', name: 'shooting star', keywords: ['star']},
      {emoji: '☁️', name: 'cloud', keywords: ['weather']},
      {emoji: '⛅', name: 'sun behind cloud', keywords: ['weather']},
      {emoji: '⛈️', name: 'cloud with lightning and rain', keywords: ['storm']},
      {emoji: '🌤️', name: 'sun behind small cloud', keywords: ['weather']},
      {emoji: '🌥️', name: 'sun behind large cloud', keywords: ['weather']},
      {emoji: '🌦️', name: 'sun behind rain cloud', keywords: ['weather']},
      {emoji: '🌧️', name: 'cloud with rain', keywords: ['rain']},
      {emoji: '🌨️', name: 'cloud with snow', keywords: ['snow']},
      {emoji: '🌩️', name: 'cloud with lightning', keywords: ['storm']},
      {emoji: '🌪️', name: 'tornado', keywords: ['tornado']},
      {emoji: '🌫️', name: 'fog', keywords: ['fog']},
      {emoji: '🌬️', name: 'wind face', keywords: ['wind']},
      {emoji: '🌈', name: 'rainbow', keywords: ['rainbow']},
      {emoji: '☂️', name: 'umbrella', keywords: ['rain']},
      {emoji: '☔', name: 'umbrella with rain drops', keywords: ['rain']},
      {emoji: '⚡', name: 'high voltage', keywords: ['lightning', 'zap']},
      {emoji: '❄️', name: 'snowflake', keywords: ['cold', 'snow']},
      {emoji: '☃️', name: 'snowman', keywords: ['winter']},
      {emoji: '⛄', name: 'snowman without snow', keywords: ['winter']},
      {emoji: '☄️', name: 'comet', keywords: ['space']},
      {emoji: '🔥', name: 'fire', keywords: ['hot', 'flame']},
      {emoji: '💧', name: 'droplet', keywords: ['water']},
      {emoji: '🌊', name: 'water wave', keywords: ['ocean']},
    ],
  },
  {
    name: 'Food & Drink',
    emojis: [
      {emoji: '🍎', name: 'red apple', keywords: ['fruit']},
      {emoji: '🍏', name: 'green apple', keywords: ['fruit']},
      {emoji: '🍐', name: 'pear', keywords: ['fruit']},
      {emoji: '🍊', name: 'tangerine', keywords: ['orange', 'fruit']},
      {emoji: '🍋', name: 'lemon', keywords: ['fruit']},
      {emoji: '🍌', name: 'banana', keywords: ['fruit']},
      {emoji: '🍉', name: 'watermelon', keywords: ['fruit']},
      {emoji: '🍇', name: 'grapes', keywords: ['fruit']},
      {emoji: '🍓', name: 'strawberry', keywords: ['fruit']},
      {emoji: '🫐', name: 'blueberries', keywords: ['fruit']},
      {emoji: '🍈', name: 'melon', keywords: ['fruit']},
      {emoji: '🍒', name: 'cherries', keywords: ['fruit']},
      {emoji: '🍑', name: 'peach', keywords: ['fruit']},
      {emoji: '🥭', name: 'mango', keywords: ['fruit']},
      {emoji: '🍍', name: 'pineapple', keywords: ['fruit']},
      {emoji: '🥥', name: 'coconut', keywords: ['fruit']},
      {emoji: '🥝', name: 'kiwi fruit', keywords: ['fruit']},
      {emoji: '🍅', name: 'tomato', keywords: ['vegetable']},
      {emoji: '🍆', name: 'eggplant', keywords: ['vegetable']},
      {emoji: '🥑', name: 'avocado', keywords: ['fruit']},
      {emoji: '🥦', name: 'broccoli', keywords: ['vegetable']},
      {emoji: '🥬', name: 'leafy green', keywords: ['vegetable']},
      {emoji: '🥒', name: 'cucumber', keywords: ['vegetable']},
      {emoji: '🌶️', name: 'hot pepper', keywords: ['spicy']},
      {emoji: '🫑', name: 'bell pepper', keywords: ['vegetable']},
      {emoji: '🌽', name: 'ear of corn', keywords: ['corn']},
      {emoji: '🥕', name: 'carrot', keywords: ['vegetable']},
      {emoji: '🧄', name: 'garlic', keywords: ['vegetable']},
      {emoji: '🧅', name: 'onion', keywords: ['vegetable']},
      {emoji: '🥔', name: 'potato', keywords: ['vegetable']},
      {emoji: '🍠', name: 'roasted sweet potato', keywords: ['vegetable']},
      {emoji: '🥐', name: 'croissant', keywords: ['bread']},
      {emoji: '🥖', name: 'baguette bread', keywords: ['bread']},
      {emoji: '🥨', name: 'pretzel', keywords: ['bread']},
      {emoji: '🧀', name: 'cheese wedge', keywords: ['cheese']},
      {emoji: '🥚', name: 'egg', keywords: ['breakfast']},
      {emoji: '🍳', name: 'cooking', keywords: ['egg', 'breakfast']},
      {emoji: '🧈', name: 'butter', keywords: ['butter']},
      {emoji: '🥞', name: 'pancakes', keywords: ['breakfast']},
      {emoji: '🧇', name: 'waffle', keywords: ['breakfast']},
      {emoji: '🥓', name: 'bacon', keywords: ['meat']},
      {emoji: '🥩', name: 'cut of meat', keywords: ['steak']},
      {emoji: '🍗', name: 'poultry leg', keywords: ['chicken']},
      {emoji: '🍖', name: 'meat on bone', keywords: ['meat']},
      {emoji: '🌭', name: 'hot dog', keywords: ['hotdog']},
      {emoji: '🍔', name: 'hamburger', keywords: ['burger']},
      {emoji: '🍟', name: 'french fries', keywords: ['fries']},
      {emoji: '🍕', name: 'pizza', keywords: ['pizza']},
      {emoji: '🥪', name: 'sandwich', keywords: ['sandwich']},
      {emoji: '🥙', name: 'stuffed flatbread', keywords: ['pita']},
      {emoji: '🧆', name: 'falafel', keywords: ['food']},
      {emoji: '🌮', name: 'taco', keywords: ['mexican']},
      {emoji: '🌯', name: 'burrito', keywords: ['mexican']},
      {emoji: '🫔', name: 'tamale', keywords: ['mexican']},
      {emoji: '🥗', name: 'green salad', keywords: ['salad']},
      {emoji: '🥘', name: 'shallow pan of food', keywords: ['paella']},
      {emoji: '🫕', name: 'fondue', keywords: ['cheese']},
      {emoji: '🥫', name: 'canned food', keywords: ['can']},
      {emoji: '🍝', name: 'spaghetti', keywords: ['pasta']},
      {emoji: '🍜', name: 'steaming bowl', keywords: ['noodles']},
      {emoji: '🍲', name: 'pot of food', keywords: ['stew']},
      {emoji: '🍛', name: 'curry rice', keywords: ['curry']},
      {emoji: '🍣', name: 'sushi', keywords: ['sushi']},
      {emoji: '🍱', name: 'bento box', keywords: ['bento']},
      {emoji: '🥟', name: 'dumpling', keywords: ['dumpling']},
      {emoji: '🦪', name: 'oyster', keywords: ['oyster']},
      {emoji: '🍤', name: 'fried shrimp', keywords: ['shrimp']},
      {emoji: '🍙', name: 'rice ball', keywords: ['rice']},
      {emoji: '🍚', name: 'cooked rice', keywords: ['rice']},
      {emoji: '🍘', name: 'rice cracker', keywords: ['rice']},
      {emoji: '🍥', name: 'fish cake with swirl', keywords: ['fish']},
      {emoji: '🥠', name: 'fortune cookie', keywords: ['cookie']},
      {emoji: '🥮', name: 'moon cake', keywords: ['cake']},
      {emoji: '🍢', name: 'oden', keywords: ['skewer']},
      {emoji: '🍡', name: 'dango', keywords: ['dessert']},
      {emoji: '🍧', name: 'shaved ice', keywords: ['dessert']},
      {emoji: '🍨', name: 'ice cream', keywords: ['dessert']},
      {emoji: '🍦', name: 'soft ice cream', keywords: ['dessert']},
      {emoji: '🥧', name: 'pie', keywords: ['dessert']},
      {emoji: '🧁', name: 'cupcake', keywords: ['dessert']},
      {emoji: '🍰', name: 'shortcake', keywords: ['cake']},
      {emoji: '🎂', name: 'birthday cake', keywords: ['birthday']},
      {emoji: '🍮', name: 'custard', keywords: ['dessert']},
      {emoji: '🍭', name: 'lollipop', keywords: ['candy']},
      {emoji: '🍬', name: 'candy', keywords: ['sweet']},
      {emoji: '🍫', name: 'chocolate bar', keywords: ['chocolate']},
      {emoji: '🍿', name: 'popcorn', keywords: ['popcorn']},
      {emoji: '🍩', name: 'doughnut', keywords: ['donut']},
      {emoji: '🍪', name: 'cookie', keywords: ['cookie']},
      {emoji: '🌰', name: 'chestnut', keywords: ['nut']},
      {emoji: '🥜', name: 'peanuts', keywords: ['nut']},
      {emoji: '🍯', name: 'honey pot', keywords: ['honey']},
      {emoji: '🥛', name: 'glass of milk', keywords: ['milk']},
      {emoji: '🍼', name: 'baby bottle', keywords: ['milk']},
      {emoji: '☕', name: 'hot beverage', keywords: ['coffee', 'tea']},
      {emoji: '🫖', name: 'teapot', keywords: ['tea']},
      {emoji: '🍵', name: 'teacup without handle', keywords: ['tea']},
      {emoji: '🍶', name: 'sake', keywords: ['sake']},
      {emoji: '🍾', name: 'bottle with popping cork', keywords: ['champagne']},
      {emoji: '🍷', name: 'wine glass', keywords: ['wine']},
      {emoji: '🍸', name: 'cocktail glass', keywords: ['cocktail']},
      {emoji: '🍹', name: 'tropical drink', keywords: ['drink']},
      {emoji: '🍺', name: 'beer mug', keywords: ['beer']},
      {emoji: '🍻', name: 'clinking beer mugs', keywords: ['cheers']},
      {emoji: '🥂', name: 'clinking glasses', keywords: ['cheers']},
      {emoji: '🥃', name: 'tumbler glass', keywords: ['whiskey']},
      {emoji: '🥤', name: 'cup with straw', keywords: ['soda']},
      {emoji: '🧋', name: 'bubble tea', keywords: ['boba']},
      {emoji: '🧃', name: 'beverage box', keywords: ['juice']},
      {emoji: '🧉', name: 'mate', keywords: ['drink']},
      {emoji: '🧊', name: 'ice', keywords: ['cold']},
      {emoji: '🥢', name: 'chopsticks', keywords: ['chopsticks']},
      {emoji: '🍽️', name: 'fork and knife with plate', keywords: ['dinner']},
      {emoji: '🍴', name: 'fork and knife', keywords: ['cutlery']},
      {emoji: '🥄', name: 'spoon', keywords: ['spoon']},
    ],
  },
  {
    name: 'Objects',
    emojis: [
      {emoji: '⌚', name: 'watch', keywords: ['time']},
      {emoji: '📱', name: 'mobile phone', keywords: ['smartphone']},
      {emoji: '📲', name: 'mobile phone with arrow', keywords: ['call']},
      {emoji: '💻', name: 'laptop', keywords: ['computer']},
      {emoji: '⌨️', name: 'keyboard', keywords: ['type']},
      {emoji: '🖥️', name: 'desktop computer', keywords: ['computer']},
      {emoji: '🖨️', name: 'printer', keywords: ['print']},
      {emoji: '🖱️', name: 'computer mouse', keywords: ['mouse']},
      {emoji: '🖲️', name: 'trackball', keywords: ['computer']},
      {emoji: '🕹️', name: 'joystick', keywords: ['game']},
      {emoji: '🗜️', name: 'clamp', keywords: ['tool']},
      {emoji: '💾', name: 'floppy disk', keywords: ['save']},
      {emoji: '💿', name: 'optical disk', keywords: ['cd']},
      {emoji: '📀', name: 'dvd', keywords: ['disk']},
      {emoji: '📼', name: 'videocassette', keywords: ['vhs']},
      {emoji: '📷', name: 'camera', keywords: ['photo']},
      {emoji: '📸', name: 'camera with flash', keywords: ['photo']},
      {emoji: '📹', name: 'video camera', keywords: ['video']},
      {emoji: '🎥', name: 'movie camera', keywords: ['film']},
      {emoji: '📽️', name: 'film projector', keywords: ['movie']},
      {emoji: '🎞️', name: 'film frames', keywords: ['movie']},
      {emoji: '📞', name: 'telephone receiver', keywords: ['phone']},
      {emoji: '☎️', name: 'telephone', keywords: ['phone']},
      {emoji: '📟', name: 'pager', keywords: ['beeper']},
      {emoji: '📠', name: 'fax machine', keywords: ['fax']},
      {emoji: '📺', name: 'television', keywords: ['tv']},
      {emoji: '📻', name: 'radio', keywords: ['radio']},
      {emoji: '🎙️', name: 'studio microphone', keywords: ['mic']},
      {emoji: '🎚️', name: 'level slider', keywords: ['music']},
      {emoji: '🎛️', name: 'control knobs', keywords: ['music']},
      {emoji: '🧭', name: 'compass', keywords: ['direction']},
      {emoji: '⏱️', name: 'stopwatch', keywords: ['time']},
      {emoji: '⏲️', name: 'timer clock', keywords: ['time']},
      {emoji: '⏰', name: 'alarm clock', keywords: ['morning']},
      {emoji: '🕰️', name: 'mantelpiece clock', keywords: ['time']},
      {emoji: '⌛', name: 'hourglass done', keywords: ['time']},
      {emoji: '⏳', name: 'hourglass not done', keywords: ['time']},
      {emoji: '📡', name: 'satellite antenna', keywords: ['signal']},
      {emoji: '🔋', name: 'battery', keywords: ['power']},
      {emoji: '🔌', name: 'electric plug', keywords: ['power']},
      {emoji: '💡', name: 'light bulb', keywords: ['idea']},
      {emoji: '🔦', name: 'flashlight', keywords: ['torch']},
      {emoji: '🕯️', name: 'candle', keywords: ['light']},
      {emoji: '🪔', name: 'diya lamp', keywords: ['light']},
      {emoji: '🧯', name: 'fire extinguisher', keywords: ['fire']},
      {emoji: '🛢️', name: 'oil drum', keywords: ['oil']},
      {emoji: '💵', name: 'dollar banknote', keywords: ['money']},
      {emoji: '💴', name: 'yen banknote', keywords: ['money']},
      {emoji: '💶', name: 'euro banknote', keywords: ['money']},
      {emoji: '💷', name: 'pound banknote', keywords: ['money']},
      {emoji: '💰', name: 'money bag', keywords: ['rich']},
      {emoji: '💳', name: 'credit card', keywords: ['payment']},
      {emoji: '💎', name: 'gem stone', keywords: ['diamond']},
      {emoji: '⚖️', name: 'balance scale', keywords: ['justice']},
      {emoji: '🪜', name: 'ladder', keywords: ['climb']},
      {emoji: '🧰', name: 'toolbox', keywords: ['tools']},
      {emoji: '🔧', name: 'wrench', keywords: ['tool']},
      {emoji: '🔨', name: 'hammer', keywords: ['tool']},
      {emoji: '⚒️', name: 'hammer and pick', keywords: ['tools']},
      {emoji: '🛠️', name: 'hammer and wrench', keywords: ['tools']},
      {emoji: '⛏️', name: 'pick', keywords: ['tool']},
      {emoji: '🔩', name: 'nut and bolt', keywords: ['tool']},
      {emoji: '⚙️', name: 'gear', keywords: ['settings']},
      {emoji: '🪤', name: 'mouse trap', keywords: ['trap']},
      {emoji: '🧱', name: 'brick', keywords: ['wall']},
      {emoji: '⛓️', name: 'chains', keywords: ['chain']},
      {emoji: '🧲', name: 'magnet', keywords: ['attraction']},
      {emoji: '🔫', name: 'pistol', keywords: ['gun']},
      {emoji: '💣', name: 'bomb', keywords: ['boom']},
      {emoji: '🧨', name: 'firecracker', keywords: ['explosive']},
      {emoji: '🪓', name: 'axe', keywords: ['chop']},
      {emoji: '🔪', name: 'kitchen knife', keywords: ['cut']},
      {emoji: '🗡️', name: 'dagger', keywords: ['weapon']},
      {emoji: '⚔️', name: 'crossed swords', keywords: ['battle']},
      {emoji: '🛡️', name: 'shield', keywords: ['protect']},
      {emoji: '🚬', name: 'cigarette', keywords: ['smoking']},
      {emoji: '⚰️', name: 'coffin', keywords: ['death']},
      {emoji: '⚱️', name: 'funeral urn', keywords: ['death']},
      {emoji: '🏺', name: 'amphora', keywords: ['jar']},
      {emoji: '🔮', name: 'crystal ball', keywords: ['magic']},
      {emoji: '📿', name: 'prayer beads', keywords: ['rosary']},
      {emoji: '🧿', name: 'nazar amulet', keywords: ['evil eye']},
      {emoji: '💈', name: 'barber pole', keywords: ['haircut']},
      {emoji: '⚗️', name: 'alembic', keywords: ['chemistry']},
      {emoji: '🔭', name: 'telescope', keywords: ['stars']},
      {emoji: '🔬', name: 'microscope', keywords: ['science']},
      {emoji: '🕳️', name: 'hole', keywords: ['hole']},
      {emoji: '🩹', name: 'adhesive bandage', keywords: ['bandaid']},
      {emoji: '🩺', name: 'stethoscope', keywords: ['doctor']},
      {emoji: '💊', name: 'pill', keywords: ['medicine']},
      {emoji: '💉', name: 'syringe', keywords: ['shot']},
      {emoji: '🩸', name: 'drop of blood', keywords: ['blood']},
      {emoji: '🧬', name: 'dna', keywords: ['genetics']},
      {emoji: '🦠', name: 'microbe', keywords: ['germ']},
      {emoji: '🧫', name: 'petri dish', keywords: ['biology']},
      {emoji: '🧪', name: 'test tube', keywords: ['science']},
      {emoji: '🌡️', name: 'thermometer', keywords: ['temperature']},
      {emoji: '🧹', name: 'broom', keywords: ['sweep']},
      {emoji: '🧺', name: 'basket', keywords: ['laundry']},
      {emoji: '🧻', name: 'roll of paper', keywords: ['toilet paper']},
      {emoji: '🚽', name: 'toilet', keywords: ['bathroom']},
      {emoji: '🚰', name: 'potable water', keywords: ['faucet']},
      {emoji: '🚿', name: 'shower', keywords: ['bath']},
      {emoji: '🛁', name: 'bathtub', keywords: ['bath']},
      {emoji: '🛀', name: 'person taking bath', keywords: ['bath']},
      {emoji: '🧼', name: 'soap', keywords: ['clean']},
      {emoji: '🪒', name: 'razor', keywords: ['shave']},
      {emoji: '🧽', name: 'sponge', keywords: ['clean']},
      {emoji: '🧴', name: 'lotion bottle', keywords: ['lotion']},
      {emoji: '🔑', name: 'key', keywords: ['lock']},
      {emoji: '🗝️', name: 'old key', keywords: ['lock']},
      {emoji: '🚪', name: 'door', keywords: ['door']},
      {emoji: '🪑', name: 'chair', keywords: ['seat']},
      {emoji: '🛋️', name: 'couch and lamp', keywords: ['sofa']},
      {emoji: '🛏️', name: 'bed', keywords: ['sleep']},
      {emoji: '🛌', name: 'person in bed', keywords: ['sleep']},
      {emoji: '🧸', name: 'teddy bear', keywords: ['toy']},
      {emoji: '🖼️', name: 'framed picture', keywords: ['art']},
      {emoji: '🛍️', name: 'shopping bags', keywords: ['shopping']},
      {emoji: '🎁', name: 'wrapped gift', keywords: ['present']},
      {emoji: '🎈', name: 'balloon', keywords: ['party']},
      {emoji: '🎏', name: 'carp streamer', keywords: ['celebration']},
      {emoji: '🎀', name: 'ribbon', keywords: ['bow']},
      {emoji: '🎊', name: 'confetti ball', keywords: ['celebration']},
      {emoji: '🎉', name: 'party popper', keywords: ['party']},
      {emoji: '🎎', name: 'japanese dolls', keywords: ['dolls']},
      {emoji: '🏮', name: 'red paper lantern', keywords: ['lantern']},
      {emoji: '🎐', name: 'wind chime', keywords: ['chime']},
      {emoji: '🧧', name: 'red envelope', keywords: ['gift']},
      {emoji: '✉️', name: 'envelope', keywords: ['letter']},
      {emoji: '📩', name: 'envelope with arrow', keywords: ['email']},
      {emoji: '📨', name: 'incoming envelope', keywords: ['email']},
      {emoji: '📧', name: 'e-mail', keywords: ['email']},
      {emoji: '💌', name: 'love letter', keywords: ['email']},
      {emoji: '📥', name: 'inbox tray', keywords: ['receive']},
      {emoji: '📤', name: 'outbox tray', keywords: ['send']},
      {emoji: '📦', name: 'package', keywords: ['box']},
      {emoji: '🏷️', name: 'label', keywords: ['tag']},
      {emoji: '📪', name: 'closed mailbox with lowered flag', keywords: ['mail']},
      {emoji: '📫', name: 'closed mailbox with raised flag', keywords: ['mail']},
      {emoji: '📬', name: 'open mailbox with raised flag', keywords: ['mail']},
      {emoji: '📭', name: 'open mailbox with lowered flag', keywords: ['mail']},
      {emoji: '📮', name: 'postbox', keywords: ['mail']},
      {emoji: '📯', name: 'postal horn', keywords: ['post']},
      {emoji: '📜', name: 'scroll', keywords: ['paper']},
      {emoji: '📃', name: 'page with curl', keywords: ['document']},
      {emoji: '📄', name: 'page facing up', keywords: ['document']},
      {emoji: '📑', name: 'bookmark tabs', keywords: ['tabs']},
      {emoji: '🧾', name: 'receipt', keywords: ['receipt']},
      {emoji: '📊', name: 'bar chart', keywords: ['graph']},
      {emoji: '📈', name: 'chart increasing', keywords: ['graph']},
      {emoji: '📉', name: 'chart decreasing', keywords: ['graph']},
      {emoji: '🗒️', name: 'spiral notepad', keywords: ['note']},
      {emoji: '🗓️', name: 'spiral calendar', keywords: ['calendar']},
      {emoji: '📆', name: 'tear-off calendar', keywords: ['calendar']},
      {emoji: '📅', name: 'calendar', keywords: ['date']},
      {emoji: '🗑️', name: 'wastebasket', keywords: ['trash']},
      {emoji: '📇', name: 'card index', keywords: ['rolodex']},
      {emoji: '🗃️', name: 'card file box', keywords: ['file']},
      {emoji: '🗳️', name: 'ballot box', keywords: ['vote']},
      {emoji: '🗄️', name: 'file cabinet', keywords: ['filing']},
      {emoji: '📋', name: 'clipboard', keywords: ['paste']},
      {emoji: '📁', name: 'file folder', keywords: ['directory']},
      {emoji: '📂', name: 'open file folder', keywords: ['folder']},
      {emoji: '🗂️', name: 'card index dividers', keywords: ['organize']},
      {emoji: '🗞️', name: 'rolled-up newspaper', keywords: ['news']},
      {emoji: '📰', name: 'newspaper', keywords: ['press']},
      {emoji: '📓', name: 'notebook', keywords: ['book']},
      {emoji: '📔', name: 'notebook with decorative cover', keywords: ['book']},
      {emoji: '📒', name: 'ledger', keywords: ['book']},
      {emoji: '📕', name: 'closed book', keywords: ['book']},
      {emoji: '📗', name: 'green book', keywords: ['book']},
      {emoji: '📘', name: 'blue book', keywords: ['book']},
      {emoji: '📙', name: 'orange book', keywords: ['book']},
      {emoji: '📚', name: 'books', keywords: ['library']},
      {emoji: '📖', name: 'open book', keywords: ['book']},
      {emoji: '🔖', name: 'bookmark', keywords: ['bookmark']},
      {emoji: '🧷', name: 'safety pin', keywords: ['pin']},
      {emoji: '🔗', name: 'link', keywords: ['link']},
      {emoji: '📎', name: 'paperclip', keywords: ['clip']},
      {emoji: '🖇️', name: 'linked paperclips', keywords: ['clip']},
      {emoji: '📐', name: 'triangular ruler', keywords: ['ruler']},
      {emoji: '📏', name: 'straight ruler', keywords: ['ruler']},
      {emoji: '🧮', name: 'abacus', keywords: ['calculate']},
      {emoji: '📌', name: 'pushpin', keywords: ['pin']},
      {emoji: '📍', name: 'round pushpin', keywords: ['location']},
      {emoji: '✂️', name: 'scissors', keywords: ['cut']},
      {emoji: '🖊️', name: 'pen', keywords: ['pen']},
      {emoji: '🖋️', name: 'fountain pen', keywords: ['pen']},
      {emoji: '✒️', name: 'black nib', keywords: ['pen']},
      {emoji: '🖌️', name: 'paintbrush', keywords: ['art']},
      {emoji: '🖍️', name: 'crayon', keywords: ['drawing']},
      {emoji: '📝', name: 'memo', keywords: ['note']},
      {emoji: '✏️', name: 'pencil', keywords: ['pencil']},
      {emoji: '🔍', name: 'magnifying glass tilted left', keywords: ['search']},
      {emoji: '🔎', name: 'magnifying glass tilted right', keywords: ['search']},
      {emoji: '🔏', name: 'locked with pen', keywords: ['lock']},
      {emoji: '🔐', name: 'locked with key', keywords: ['secure']},
      {emoji: '🔒', name: 'locked', keywords: ['lock']},
      {emoji: '🔓', name: 'unlocked', keywords: ['unlock']},
    ],
  },
  {
    name: 'Symbols',
    emojis: [
      {emoji: '❤️', name: 'red heart', keywords: ['love']},
      {emoji: '🧡', name: 'orange heart', keywords: ['love']},
      {emoji: '💛', name: 'yellow heart', keywords: ['love']},
      {emoji: '💚', name: 'green heart', keywords: ['love']},
      {emoji: '💙', name: 'blue heart', keywords: ['love']},
      {emoji: '💜', name: 'purple heart', keywords: ['love']},
      {emoji: '🖤', name: 'black heart', keywords: ['love']},
      {emoji: '🤍', name: 'white heart', keywords: ['love']},
      {emoji: '🤎', name: 'brown heart', keywords: ['love']},
      {emoji: '💔', name: 'broken heart', keywords: ['heartbreak']},
      {emoji: '❣️', name: 'heart exclamation', keywords: ['love']},
      {emoji: '💕', name: 'two hearts', keywords: ['love']},
      {emoji: '💞', name: 'revolving hearts', keywords: ['love']},
      {emoji: '💓', name: 'beating heart', keywords: ['love']},
      {emoji: '💗', name: 'growing heart', keywords: ['love']},
      {emoji: '💖', name: 'sparkling heart', keywords: ['love']},
      {emoji: '💘', name: 'heart with arrow', keywords: ['love']},
      {emoji: '💝', name: 'heart with ribbon', keywords: ['love']},
      {emoji: '💟', name: 'heart decoration', keywords: ['love']},
      {emoji: '☮️', name: 'peace symbol', keywords: ['peace']},
      {emoji: '✝️', name: 'latin cross', keywords: ['christian']},
      {emoji: '☪️', name: 'star and crescent', keywords: ['islam']},
      {emoji: '🕉️', name: 'om', keywords: ['hindu']},
      {emoji: '☸️', name: 'wheel of dharma', keywords: ['buddhist']},
      {emoji: '✡️', name: 'star of david', keywords: ['jewish']},
      {emoji: '🔯', name: 'dotted six-pointed star', keywords: ['fortune']},
      {emoji: '🕎', name: 'menorah', keywords: ['hanukkah']},
      {emoji: '☯️', name: 'yin yang', keywords: ['balance']},
      {emoji: '☦️', name: 'orthodox cross', keywords: ['christian']},
      {emoji: '🛐', name: 'place of worship', keywords: ['religion']},
      {emoji: '⛎', name: 'ophiuchus', keywords: ['zodiac']},
      {emoji: '♈', name: 'aries', keywords: ['zodiac']},
      {emoji: '♉', name: 'taurus', keywords: ['zodiac']},
      {emoji: '♊', name: 'gemini', keywords: ['zodiac']},
      {emoji: '♋', name: 'cancer', keywords: ['zodiac']},
      {emoji: '♌', name: 'leo', keywords: ['zodiac']},
      {emoji: '♍', name: 'virgo', keywords: ['zodiac']},
      {emoji: '♎', name: 'libra', keywords: ['zodiac']},
      {emoji: '♏', name: 'scorpio', keywords: ['zodiac']},
      {emoji: '♐', name: 'sagittarius', keywords: ['zodiac']},
      {emoji: '♑', name: 'capricorn', keywords: ['zodiac']},
      {emoji: '♒', name: 'aquarius', keywords: ['zodiac']},
      {emoji: '♓', name: 'pisces', keywords: ['zodiac']},
      {emoji: '🆔', name: 'id button', keywords: ['identity']},
      {emoji: '⚛️', name: 'atom symbol', keywords: ['science']},
      {emoji: '🉑', name: 'japanese acceptable button', keywords: ['accept']},
      {emoji: '☢️', name: 'radioactive', keywords: ['nuclear']},
      {emoji: '☣️', name: 'biohazard', keywords: ['danger']},
      {emoji: '📴', name: 'mobile phone off', keywords: ['mute']},
      {emoji: '📳', name: 'vibration mode', keywords: ['phone']},
      {emoji: '🈶', name: 'japanese not free of charge button', keywords: ['pay']},
      {emoji: '🈚', name: 'japanese free of charge button', keywords: ['free']},
      {emoji: '🈸', name: 'japanese application button', keywords: ['app']},
      {emoji: '🈺', name: 'japanese open for business button', keywords: ['open']},
      {emoji: '🈷️', name: 'japanese monthly amount button', keywords: ['month']},
      {emoji: '✴️', name: 'eight-pointed star', keywords: ['star']},
      {emoji: '🆚', name: 'vs button', keywords: ['versus']},
      {emoji: '💮', name: 'white flower', keywords: ['flower']},
      {emoji: '🉐', name: 'japanese bargain button', keywords: ['sale']},
      {emoji: '㊙️', name: 'japanese secret button', keywords: ['secret']},
      {emoji: '㊗️', name: 'japanese congratulations button', keywords: ['congrats']},
      {emoji: '🈴', name: 'japanese passing grade button', keywords: ['pass']},
      {emoji: '🈵', name: 'japanese no vacancy button', keywords: ['full']},
      {emoji: '🈹', name: 'japanese discount button', keywords: ['discount']},
      {emoji: '🈲', name: 'japanese prohibited button', keywords: ['forbidden']},
      {emoji: '🅰️', name: 'a button blood type', keywords: ['a']},
      {emoji: '🅱️', name: 'b button blood type', keywords: ['b']},
      {emoji: '🆎', name: 'ab button blood type', keywords: ['ab']},
      {emoji: '🆑', name: 'cl button', keywords: ['clear']},
      {emoji: '🅾️', name: 'o button blood type', keywords: ['o']},
      {emoji: '🆘', name: 'sos button', keywords: ['help']},
      {emoji: '❌', name: 'cross mark', keywords: ['x', 'no']},
      {emoji: '⭕', name: 'hollow red circle', keywords: ['o']},
      {emoji: '🛑', name: 'stop sign', keywords: ['stop']},
      {emoji: '⛔', name: 'no entry', keywords: ['forbidden']},
      {emoji: '📛', name: 'name badge', keywords: ['name']},
      {emoji: '🚫', name: 'prohibited', keywords: ['forbidden']},
      {emoji: '💯', name: 'hundred points', keywords: ['100']},
      {emoji: '💢', name: 'anger symbol', keywords: ['mad']},
      {emoji: '♨️', name: 'hot springs', keywords: ['hot']},
      {emoji: '🚷', name: 'no pedestrians', keywords: ['forbidden']},
      {emoji: '🚯', name: 'no littering', keywords: ['trash']},
      {emoji: '🚳', name: 'no bicycles', keywords: ['bike']},
      {emoji: '🚱', name: 'non-potable water', keywords: ['water']},
      {emoji: '🔞', name: '18+', keywords: ['adult']},
      {emoji: '📵', name: 'no mobile phones', keywords: ['phone']},
      {emoji: '🚭', name: 'no smoking', keywords: ['cigarette']},
      {emoji: '❗', name: 'exclamation mark', keywords: ['!']},
      {emoji: '❕', name: 'white exclamation mark', keywords: ['!']},
      {emoji: '❓', name: 'question mark', keywords: ['?']},
      {emoji: '❔', name: 'white question mark', keywords: ['?']},
      {emoji: '‼️', name: 'double exclamation mark', keywords: ['!!']},
      {emoji: '⁉️', name: 'exclamation question mark', keywords: ['!?']},
      {emoji: '🔅', name: 'dim button', keywords: ['brightness']},
      {emoji: '🔆', name: 'bright button', keywords: ['brightness']},
      {emoji: '〽️', name: 'part alternation mark', keywords: ['graph']},
      {emoji: '⚠️', name: 'warning', keywords: ['caution']},
      {emoji: '🚸', name: 'children crossing', keywords: ['warning']},
      {emoji: '🔱', name: 'trident emblem', keywords: ['weapon']},
      {emoji: '⚜️', name: 'fleur-de-lis', keywords: ['decorative']},
      {emoji: '🔰', name: 'japanese symbol for beginner', keywords: ['beginner']},
      {emoji: '♻️', name: 'recycling symbol', keywords: ['environment']},
      {emoji: '✅', name: 'check mark button', keywords: ['yes']},
      {emoji: '🈯', name: 'japanese reserved button', keywords: ['reserved']},
      {emoji: '💹', name: 'chart increasing with yen', keywords: ['graph']},
      {emoji: '❇️', name: 'sparkle', keywords: ['star']},
      {emoji: '✳️', name: 'eight-spoked asterisk', keywords: ['star']},
      {emoji: '❎', name: 'cross mark button', keywords: ['x']},
      {emoji: '🌐', name: 'globe with meridians', keywords: ['world']},
      {emoji: '💠', name: 'diamond with a dot', keywords: ['jewel']},
      {emoji: 'Ⓜ️', name: 'circled m', keywords: ['metro']},
      {emoji: '🌀', name: 'cyclone', keywords: ['swirl']},
      {emoji: '💤', name: 'zzz', keywords: ['sleep']},
      {emoji: '🏧', name: 'atm sign', keywords: ['bank']},
      {emoji: '🚾', name: 'water closet', keywords: ['wc']},
      {emoji: '♿', name: 'wheelchair symbol', keywords: ['accessibility']},
      {emoji: '🅿️', name: 'p button', keywords: ['parking']},
      {emoji: '🈳', name: 'japanese vacancy button', keywords: ['available']},
      {emoji: '🈂️', name: 'japanese service charge button', keywords: ['service']},
      {emoji: '🛂', name: 'passport control', keywords: ['customs']},
      {emoji: '🛃', name: 'customs', keywords: ['baggage']},
      {emoji: '🛄', name: 'baggage claim', keywords: ['airport']},
      {emoji: '🛅', name: 'left luggage', keywords: ['baggage']},
      {emoji: '🚹', name: 'mens room', keywords: ['bathroom']},
      {emoji: '🚺', name: 'womens room', keywords: ['bathroom']},
      {emoji: '🚼', name: 'baby symbol', keywords: ['child']},
      {emoji: '🚻', name: 'restroom', keywords: ['bathroom']},
      {emoji: '🚮', name: 'litter in bin sign', keywords: ['trash']},
      {emoji: '🎦', name: 'cinema', keywords: ['movie']},
      {emoji: '📶', name: 'antenna bars', keywords: ['signal']},
      {emoji: '🈁', name: 'japanese here button', keywords: ['here']},
      {emoji: '🔣', name: 'input symbols', keywords: ['symbols']},
      {emoji: '🔤', name: 'input latin letters', keywords: ['abc']},
      {emoji: '🔡', name: 'input latin lowercase', keywords: ['abc']},
      {emoji: '🔠', name: 'input latin uppercase', keywords: ['ABC']},
      {emoji: '🆖', name: 'ng button', keywords: ['no good']},
      {emoji: '🆗', name: 'ok button', keywords: ['ok']},
      {emoji: '🆙', name: 'up button', keywords: ['up']},
      {emoji: '🆒', name: 'cool button', keywords: ['cool']},
      {emoji: '🆕', name: 'new button', keywords: ['new']},
      {emoji: '🆓', name: 'free button', keywords: ['free']},
      {emoji: '0️⃣', name: 'keycap 0', keywords: ['0']},
      {emoji: '1️⃣', name: 'keycap 1', keywords: ['1']},
      {emoji: '2️⃣', name: 'keycap 2', keywords: ['2']},
      {emoji: '3️⃣', name: 'keycap 3', keywords: ['3']},
      {emoji: '4️⃣', name: 'keycap 4', keywords: ['4']},
      {emoji: '5️⃣', name: 'keycap 5', keywords: ['5']},
      {emoji: '6️⃣', name: 'keycap 6', keywords: ['6']},
      {emoji: '7️⃣', name: 'keycap 7', keywords: ['7']},
      {emoji: '8️⃣', name: 'keycap 8', keywords: ['8']},
      {emoji: '9️⃣', name: 'keycap 9', keywords: ['9']},
      {emoji: '🔟', name: 'keycap 10', keywords: ['10']},
      {emoji: '🔢', name: 'input numbers', keywords: ['123']},
      {emoji: '#️⃣', name: 'keycap #', keywords: ['hash']},
      {emoji: '*️⃣', name: 'keycap *', keywords: ['star']},
      {emoji: '⏏️', name: 'eject button', keywords: ['eject']},
      {emoji: '▶️', name: 'play button', keywords: ['play']},
      {emoji: '⏸️', name: 'pause button', keywords: ['pause']},
      {emoji: '⏯️', name: 'play or pause button', keywords: ['play']},
      {emoji: '⏹️', name: 'stop button', keywords: ['stop']},
      {emoji: '⏺️', name: 'record button', keywords: ['record']},
      {emoji: '⏭️', name: 'next track button', keywords: ['next']},
      {emoji: '⏮️', name: 'last track button', keywords: ['previous']},
      {emoji: '⏩', name: 'fast-forward button', keywords: ['fast']},
      {emoji: '⏪', name: 'fast reverse button', keywords: ['rewind']},
      {emoji: '⏫', name: 'fast up button', keywords: ['up']},
      {emoji: '⏬', name: 'fast down button', keywords: ['down']},
      {emoji: '◀️', name: 'reverse button', keywords: ['left']},
      {emoji: '🔼', name: 'upwards button', keywords: ['up']},
      {emoji: '🔽', name: 'downwards button', keywords: ['down']},
      {emoji: '➡️', name: 'right arrow', keywords: ['right']},
      {emoji: '⬅️', name: 'left arrow', keywords: ['left']},
      {emoji: '⬆️', name: 'up arrow', keywords: ['up']},
      {emoji: '⬇️', name: 'down arrow', keywords: ['down']},
      {emoji: '↗️', name: 'up-right arrow', keywords: ['diagonal']},
      {emoji: '↘️', name: 'down-right arrow', keywords: ['diagonal']},
      {emoji: '↙️', name: 'down-left arrow', keywords: ['diagonal']},
      {emoji: '↖️', name: 'up-left arrow', keywords: ['diagonal']},
      {emoji: '↕️', name: 'up-down arrow', keywords: ['vertical']},
      {emoji: '↔️', name: 'left-right arrow', keywords: ['horizontal']},
      {emoji: '↪️', name: 'left arrow curving right', keywords: ['turn']},
      {emoji: '↩️', name: 'right arrow curving left', keywords: ['return']},
      {emoji: '⤴️', name: 'right arrow curving up', keywords: ['up']},
      {emoji: '⤵️', name: 'right arrow curving down', keywords: ['down']},
      {emoji: '🔀', name: 'shuffle tracks button', keywords: ['shuffle']},
      {emoji: '🔁', name: 'repeat button', keywords: ['loop']},
      {emoji: '🔂', name: 'repeat single button', keywords: ['loop']},
      {emoji: '🔄', name: 'counterclockwise arrows button', keywords: ['sync']},
      {emoji: '🔃', name: 'clockwise vertical arrows', keywords: ['refresh']},
      {emoji: '🎵', name: 'musical note', keywords: ['music']},
      {emoji: '🎶', name: 'musical notes', keywords: ['music']},
      {emoji: '➕', name: 'plus', keywords: ['plus']},
      {emoji: '➖', name: 'minus', keywords: ['minus']},
      {emoji: '➗', name: 'divide', keywords: ['division']},
      {emoji: '✖️', name: 'multiply', keywords: ['x']},
      {emoji: '♾️', name: 'infinity', keywords: ['forever']},
      {emoji: '💲', name: 'heavy dollar sign', keywords: ['money']},
      {emoji: '💱', name: 'currency exchange', keywords: ['money']},
      {emoji: '™️', name: 'trade mark', keywords: ['trademark']},
      {emoji: '©️', name: 'copyright', keywords: ['copyright']},
      {emoji: '®️', name: 'registered', keywords: ['registered']},
      {emoji: '〰️', name: 'wavy dash', keywords: ['wave']},
      {emoji: '➰', name: 'curly loop', keywords: ['loop']},
      {emoji: '➿', name: 'double curly loop', keywords: ['loop']},
      {emoji: '🔚', name: 'end arrow', keywords: ['end']},
      {emoji: '🔙', name: 'back arrow', keywords: ['back']},
      {emoji: '🔛', name: 'on arrow', keywords: ['on']},
      {emoji: '🔝', name: 'top arrow', keywords: ['top']},
      {emoji: '🔜', name: 'soon arrow', keywords: ['soon']},
      {emoji: '✔️', name: 'check mark', keywords: ['yes']},
      {emoji: '☑️', name: 'check box with check', keywords: ['done']},
      {emoji: '🔘', name: 'radio button', keywords: ['radio']},
      {emoji: '🔴', name: 'red circle', keywords: ['red']},
      {emoji: '🟠', name: 'orange circle', keywords: ['orange']},
      {emoji: '🟡', name: 'yellow circle', keywords: ['yellow']},
      {emoji: '🟢', name: 'green circle', keywords: ['green']},
      {emoji: '🔵', name: 'blue circle', keywords: ['blue']},
      {emoji: '🟣', name: 'purple circle', keywords: ['purple']},
      {emoji: '⚫', name: 'black circle', keywords: ['black']},
      {emoji: '⚪', name: 'white circle', keywords: ['white']},
      {emoji: '🟤', name: 'brown circle', keywords: ['brown']},
      {emoji: '🔺', name: 'red triangle pointed up', keywords: ['triangle']},
      {emoji: '🔻', name: 'red triangle pointed down', keywords: ['triangle']},
      {emoji: '🔸', name: 'small orange diamond', keywords: ['diamond']},
      {emoji: '🔹', name: 'small blue diamond', keywords: ['diamond']},
      {emoji: '🔶', name: 'large orange diamond', keywords: ['diamond']},
      {emoji: '🔷', name: 'large blue diamond', keywords: ['diamond']},
      {emoji: '🔳', name: 'white square button', keywords: ['square']},
      {emoji: '🔲', name: 'black square button', keywords: ['square']},
      {emoji: '▪️', name: 'black small square', keywords: ['square']},
      {emoji: '▫️', name: 'white small square', keywords: ['square']},
      {emoji: '◾', name: 'black medium-small square', keywords: ['square']},
      {emoji: '◽', name: 'white medium-small square', keywords: ['square']},
      {emoji: '◼️', name: 'black medium square', keywords: ['square']},
      {emoji: '◻️', name: 'white medium square', keywords: ['square']},
      {emoji: '🟥', name: 'red square', keywords: ['red']},
      {emoji: '🟧', name: 'orange square', keywords: ['orange']},
      {emoji: '🟨', name: 'yellow square', keywords: ['yellow']},
      {emoji: '🟩', name: 'green square', keywords: ['green']},
      {emoji: '🟦', name: 'blue square', keywords: ['blue']},
      {emoji: '🟪', name: 'purple square', keywords: ['purple']},
      {emoji: '⬛', name: 'black large square', keywords: ['black']},
      {emoji: '⬜', name: 'white large square', keywords: ['white']},
      {emoji: '🟫', name: 'brown square', keywords: ['brown']},
      {emoji: '🔈', name: 'speaker low volume', keywords: ['volume']},
      {emoji: '🔇', name: 'muted speaker', keywords: ['mute']},
      {emoji: '🔉', name: 'speaker medium volume', keywords: ['volume']},
      {emoji: '🔊', name: 'speaker high volume', keywords: ['loud']},
      {emoji: '🔔', name: 'bell', keywords: ['notification']},
      {emoji: '🔕', name: 'bell with slash', keywords: ['silent']},
      {emoji: '📣', name: 'megaphone', keywords: ['announcement']},
      {emoji: '📢', name: 'loudspeaker', keywords: ['announcement']},
      {emoji: '👁️‍🗨️', name: 'eye in speech bubble', keywords: ['witness']},
      {emoji: '💬', name: 'speech balloon', keywords: ['comment']},
      {emoji: '💭', name: 'thought balloon', keywords: ['thinking']},
      {emoji: '🗯️', name: 'right anger bubble', keywords: ['mad']},
      {emoji: '♠️', name: 'spade suit', keywords: ['cards']},
      {emoji: '♣️', name: 'club suit', keywords: ['cards']},
      {emoji: '♥️', name: 'heart suit', keywords: ['cards']},
      {emoji: '♦️', name: 'diamond suit', keywords: ['cards']},
      {emoji: '🃏', name: 'joker', keywords: ['cards']},
      {emoji: '🎴', name: 'flower playing cards', keywords: ['cards']},
      {emoji: '🀄', name: 'mahjong red dragon', keywords: ['game']},
      {emoji: '🕐', name: 'one oclock', keywords: ['time']},
      {emoji: '🕑', name: 'two oclock', keywords: ['time']},
      {emoji: '🕒', name: 'three oclock', keywords: ['time']},
      {emoji: '🕓', name: 'four oclock', keywords: ['time']},
      {emoji: '🕔', name: 'five oclock', keywords: ['time']},
      {emoji: '🕕', name: 'six oclock', keywords: ['time']},
      {emoji: '🕖', name: 'seven oclock', keywords: ['time']},
      {emoji: '🕗', name: 'eight oclock', keywords: ['time']},
      {emoji: '🕘', name: 'nine oclock', keywords: ['time']},
      {emoji: '🕙', name: 'ten oclock', keywords: ['time']},
      {emoji: '🕚', name: 'eleven oclock', keywords: ['time']},
      {emoji: '🕛', name: 'twelve oclock', keywords: ['time']},
      {emoji: '🕜', name: 'one-thirty', keywords: ['time']},
      {emoji: '🕝', name: 'two-thirty', keywords: ['time']},
      {emoji: '🕞', name: 'three-thirty', keywords: ['time']},
      {emoji: '🕟', name: 'four-thirty', keywords: ['time']},
      {emoji: '🕠', name: 'five-thirty', keywords: ['time']},
      {emoji: '🕡', name: 'six-thirty', keywords: ['time']},
      {emoji: '🕢', name: 'seven-thirty', keywords: ['time']},
      {emoji: '🕣', name: 'eight-thirty', keywords: ['time']},
      {emoji: '🕤', name: 'nine-thirty', keywords: ['time']},
      {emoji: '🕥', name: 'ten-thirty', keywords: ['time']},
      {emoji: '🕦', name: 'eleven-thirty', keywords: ['time']},
      {emoji: '🕧', name: 'twelve-thirty', keywords: ['time']},
    ],
  },
];
